import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const MultiListCard = () => {

    const cardDetaisl = [
        {
            title: "What we build & capabilities",
            list: [
                {
                    list1: "Products & SaaS:",
                    content: "Multi-tenant apps, portals, marketplaces, dashboards, internal tools, offline-first mobile apps."
                },
                {
                    list1: "Key capabilities:",
                    content: "Real-time events, role-based access, payments & billing, subscriptions, audit logs, internationalization, accessibility (WCAG), analytics."
                },
                {
                    list1: "Integrations:",
                    content: "Salesforce, ServiceNow, SharePoint, NetSuite, Oracle, AWS/Azure services, identity providers (OIDC/SSO)."
                },
                {
                    list1: "Tech stack:",
                    content: "Python/Django, FastAPI, Node; React/Vue, Flutter for mobile; PostgreSQL/MySQL; Redis; Kubernetes/Docker, Terraform; CI/CD with GitHub/Jenkins."
                },
                {
                    list1: "Non-AI + AI-ready:",
                    content: "Clean APIs and data pipelines so agentic AI or analytics can be layered later without refactors."
                },
                {
                    list1: "Business outcomes:",
                    content: "Faster time-to-market, predictable releases, scalable architecture, lower run costs."
                }
            ]
        },
        {
            title: "How we build (process, quality & engagement)",
            list: [
                {
                    list1: "Process:",
                    content: "Discover → Design → Deliver."
                },
                {
                    list1: "Discover:",
                    content: "Product goals, users, KPI baseline, risk & compliance."
                },
                {
                    list1: "Design:",
                    content: "IA, UX flows, design system, architecture & data model."
                },
                {
                    list1: "Deliver:",
                    content: "Iterative sprints, demos, UAT, release train."
                },
                {
                    list1: "Engineering quality:",
                    content: "Secure coding, code reviews, automated tests (unit/e2e), performance budgets, observability (metrics, logs, traces)."
                },
                {
                    list1: "Security & compliance:",
                    content: "SSO/RBAC, encryption, secrets mgmt, backups/DR, privacy controls; audit-ready change history."
                },
                {
                    list1: "DevOps & reliability:",
                    content: "IaC, blue/green or canary deploys, autoscaling, SLOs & alerts, cost monitoring."
                },
                {
                    list1: "Engagement models:",
                    content: "Fixed-scope MVP, Agile product squad, or Build-Operate-Transfer with knowledge handover and runbooks."
                },
                {
                    list1: "Next step:",
                    content: "Share your brief to get a build plan, timeline, and sprint-0 kickoff."
                }
            ]
        }
    ]

    return (
        <>
            <Row>
                {
                    cardDetaisl.map((item, index) => {
                        return (
                            <Col className='card_margin' lg="6" key={index}>  
                                <Card className='multi_list_card'>
                                    <Card.Title className='multi_list_card_content_title'>{item.title}</Card.Title>
                                    <div className='multi_list_card_content'>
                                        <ul>
                                            {
                                                item.list.map((newitem, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {newitem.list1}
                                                            <p className='list_subitem'>{newitem.content}</p>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default MultiListCard